import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/redux/store';
import { questionnairesApi } from 'app/services/questionnaires';
import { resetQuestionnaire } from '../../actions';
import lodashSet from 'lodash.set';

export interface AutomobilesStateValues {
  didYouUseAnAutomobileForYourBusinessThisYear: Nullable<TYesOrNo>;
  automobileList: AutomobileListRow[];

  // endOfAutomobileList: Nullable<string>;
}

export interface AutomobilesState {
  values: AutomobilesStateValues;
}

type automobileList = AutomobileListRow[];
export interface AutomobileListRow {
  isThisVehicleRegisteredInTheNameOfTheBusinessOrAPersonalName: Nullable<string>;
  didYouMaintainAMileageLogThisYear: Nullable<TYesOrNo>;
  pleaseUploadCopyOfMileageLog: Nullable<string>;
  makeOfTheVehicleYouUsedForYourBusinessOrTravel: Nullable<string>;
  modelOfTheVehicleYouUsedForYourBusinessOrTravel: Nullable<string>;
  yearOfTheVehicleYouUsedForYourBusinessOrTravel: Nullable<string>;
  whatDateDidYouStartUsingThisVehicleForBusiness: Nullable<string>;
  odometerReadingAtTheBeginningOfLastYear: Nullable<string>;
  odometerReadingAtTheEndOfLastYear: Nullable<string>;
  totalMilesDrivenDuringTheYear: Nullable<string>;
  howManyMilesDidYouDriveStrictlyForBusiness: Nullable<string>;
  howManyMilesDidYouCommuteDuringYear: Nullable<string>;
  howManyMilesIsItFromYourHomeToWork: Nullable<string>;
  howManyMilesDidYouDriveForPersonalUse: Nullable<string>;
  doYouOwnOrLeaseTheVehicle: Nullable<string>;
  purchaseDate: Nullable<string>;
  purchasePrice: Nullable<string>;
  didYouUseTheStandardMileageRateOrTheExpensedepreciationMethodLastYear: Nullable<string>;
  fueloilserviceCosts: Nullable<string>;
  insuranceRegistration: Nullable<string>;
  repairsreplacementstiresbatteries: Nullable<string>;
  careMaintenance: Nullable<string>;
  otherExpenses: Nullable<string>;
  doYouHaveALog: Nullable<TYesOrNo>;
  doYouHaveReceipts: Nullable<TYesOrNo>;
  wereYouReimbursedByYourEmployer: Nullable<TYesOrNo>;
  didYouPayForParking: Nullable<TYesOrNo>;
  doYouHaveAnotherVehicleAvailableToYouForPersonalUse: Nullable<TYesOrNo>;
  isThisVehicleAvailableDuringNonWorkingHours: Nullable<TYesOrNo>;
}
const initialState: AutomobilesState = {
  values: {
    didYouUseAnAutomobileForYourBusinessThisYear: null,
    automobileList: [],
  },
};

const AutomobilesSlice = createSlice({
  name: 'Automobiles',
  initialState,
  reducers: {
    reset(state) {
      state = initialState;
    },
    update(state, action: PayloadAction<AutomobilesStateValues>) {
      state.values = action.payload;
    },
    updateKey(
      state,
      action: PayloadAction<{
        key: keyof AutomobilesStateValues;
        value: any;
      }>,
    ) {
      lodashSet(state, `values.${action.payload.key}`, action.payload.value);
    },

    // Update KEY_HERE_LIST if there is a Record Here
    updateFieldArrayKey(
      state: any,
      action: PayloadAction<{
        key: keyof AutomobilesStateValues | '';
        value: any;
      }>,
    ) {
      const fieldArray =
        action.payload.value &&
        action.payload.value.map(({ ...field }) => ({
          ...field,
        }));
      if (action.payload.key === 'automobileList') {
        state.values[action.payload.key] = fieldArray;
      } else {
        lodashSet(state, `values.${action.payload.key}`, fieldArray);
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetQuestionnaire, () => initialState);

    builder.addMatcher(
      questionnairesApi.endpoints.getQuestionnaireById.matchFulfilled,
      (state, { payload }) => {
        state.values = payload.questionnaire.data.taxQuestionnaire
          ? payload.questionnaire.data.taxQuestionnaire?.additionalQuestions
              ?.automobiles?.values
          : initialState.values;
      },
    );
  },
});

export const { update, updateKey, updateFieldArrayKey } =
  AutomobilesSlice.actions;
export default AutomobilesSlice.reducer;

export const selectAutomobiles = (state: RootState) =>
  state.taxQuestionnaire.additionalQuestions.automobiles;
